import { render, staticRenderFns } from "./salesReturnStat.vue?vue&type=template&id=0666b5f4&scoped=true&"
import script from "./salesReturnStat.vue?vue&type=script&lang=js&"
export * from "./salesReturnStat.vue?vue&type=script&lang=js&"
import style0 from "./salesReturnStat.vue?vue&type=style&index=0&lang=less&"
import style1 from "./salesReturnStat.vue?vue&type=style&index=1&id=0666b5f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0666b5f4",
  null
  
)

component.options.__file = "salesReturnStat.vue"
export default component.exports